import type { Article } from "@/types/articles.types";

const storageInfoArticle: Article = {
  title: "Information sur le stockage",
  items: [
    {
      type: "title",
      content: "Stockage hors ligne",
    },
    {
      type: "paragraph",
      content: `Vos dessins sont synchronisés dans notre espace cloud sécurisés et vous pouvez y accéder depuis n'importe quel appareil lorsque vous êtes connecté. Si vous souhaitez utiliser l'application déconnecté, l'application permet de mettre les dessins hors ligne et de travailler dessus depuis n'importe ou. Vous devez ensuite vous reconnecter pour uploader vos modifications.`,
    },
    {
      type: "title",
      content: `Gestion de l'espace de stockage`,
    },
    {
      type: "paragraph",
      content: `Attention, il ne faut pas avoir trop de dessins en mode hors ligne car cela pourrait saturer la mémoire de votre appareil et dégrader votre expérience utilisateur. Pour vous aider, nous indiquons l'espace utilisé par votre stockage local.`,
    },
    {
      type: "title",
      content: `Dessins archivés`,
    },
    {
      type: "paragraph",
      content: `Lorsque vous archivez un dessin ou un projet, cela libère l'espace utilisé par ces fichiers. Les données uploadées sont toujours accessibles en ligne.`,
    },
    {
      type: "title",
      content: `Conseils pour une meilleure expérience`,
    },
    {
      type: "paragraph",
      content: `Pour une meilleure persistance des données et une utilisation optimale de l'application, il est recommandé d'utiliser le navigateur Chrome, qui est le plus adapté. De plus, vous pouvez installer l'application pour une expérience plus fluide. Des tutoriels détaillés sur l'installation sont disponibles dans la section "Aide (?)" de l'application.`,
    },
  ],
};

export default storageInfoArticle;
